exports = module.exports = require("../../node_modules/.0.28.4@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n#app {\n  margin: 60px auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.28.4@css-loader!./~/.12.2.2@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c6603ea","scoped":false,"hasInlineConfig":false}!./~/.4.0.5@less-loader/dist/cjs.js!./~/.12.2.2@vue-loader/lib/selector.js?type=styles&index=0!./example/src/App.vue
// module id = 7
// module chunks = 0